import React, { useState } from "react";
import "../../css/documents-properties/Sidebar.css";

const Sidebar = () => {
    
  return (
    <div className="documents-properties-sidebar">
      <div className="history">
        <div className="custom-text">History</div>
      </div>

      <div className="sidebar-section">
        <div className="section">
          <div className="icon-arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              stroke=""
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path
                d="M 7 5.94963 C 7 5.02553 7 4.56348 7.1395 4.32617 C 7.2607 4.11978 7.4446 3.99972 7.639 4 C 7.8626 4.00033 8.12818 4.28897 8.6594 4.86625 L 12.3866 8.9166 C 12.7274 9.2869 12.8977 9.4721 12.9594 9.6958 C 13.0135 9.8919 13.0135 10.1081 12.9594 10.3042 C 12.8977 10.5279 12.7274 10.7131 12.3866 11.0834 L 8.6594 15.1337 C 8.12818 15.711 7.8626 15.9997 7.639 16 C 7.4446 16.0003 7.2607 15.8802 7.1395 15.6738 C 7 15.4365 7 14.9745 7 14.0504 L 7 5.94963 Z"
                fill="#181818"
              />
            </svg>
          </div>
          <div className="sub-section">
            <div className="list1">
              <div className="revision">Rev: 4</div>
              <div className="date">11/06/2025</div>
            </div>
            <div className="list2">
              <div className="code">Code:4</div>
              <div className="number">#21</div>
            </div>
            <div className="list3">
              <div className="received">Received on:</div>
              <div className="number2">IDOM-WTRAN-006707</div>
            </div>
          </div>
        </div>
        <div className="box-section">
          <div className="icon-arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              stroke=""
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path
                d="M 7 5.94963 C 7 5.02553 7 4.56348 7.1395 4.32617 C 7.2607 4.11978 7.4446 3.99972 7.639 4 C 7.8626 4.00033 8.12818 4.28897 8.6594 4.86625 L 12.3866 8.9166 C 12.7274 9.2869 12.8977 9.4721 12.9594 9.6958 C 13.0135 9.8919 13.0135 10.1081 12.9594 10.3042 C 12.8977 10.5279 12.7274 10.7131 12.3866 11.0834 L 8.6594 15.1337 C 8.12818 15.711 7.8626 15.9997 7.639 16 C 7.4446 16.0003 7.2607 15.8802 7.1395 15.6738 C 7 15.4365 7 14.9745 7 14.0504 L 7 5.94963 Z"
                fill="#181818"
              />
            </svg>
          </div>
          <div className="sub-section">
            <div className="list1">
              <div className="revision">Rev: 4</div>
              <div className="date">11/06/2025</div>
            </div>
            <div className="list2">
              <div className="code">Code:4</div>
              <div className="number">#21</div>
            </div>
            <div className="list3">
              <div className="received">Received on:</div>
              <div className="number2">IDOM-WTRAN-006707</div>
            </div>
          </div>
        </div>
        <div className="box-section">
          <div className="icon-arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              stroke=""
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path
                d="M 7 5.94963 C 7 5.02553 7 4.56348 7.1395 4.32617 C 7.2607 4.11978 7.4446 3.99972 7.639 4 C 7.8626 4.00033 8.12818 4.28897 8.6594 4.86625 L 12.3866 8.9166 C 12.7274 9.2869 12.8977 9.4721 12.9594 9.6958 C 13.0135 9.8919 13.0135 10.1081 12.9594 10.3042 C 12.8977 10.5279 12.7274 10.7131 12.3866 11.0834 L 8.6594 15.1337 C 8.12818 15.711 7.8626 15.9997 7.639 16 C 7.4446 16.0003 7.2607 15.8802 7.1395 15.6738 C 7 15.4365 7 14.9745 7 14.0504 L 7 5.94963 Z"
                fill="#181818"
              />
            </svg>
          </div>
          <div className="sub-section">
            <div className="list1">
              <div className="revision">Rev: 4</div>
              <div className="date">11/06/2025</div>
            </div>
            <div className="list2">
              <div className="code">Code:4</div>
              <div className="number">#21</div>
            </div>
            <div className="list3">
              <div className="received">Received on:</div>
              <div className="number2">IDOM-WTRAN-006707</div>
            </div>
          </div>
        </div>
        <div className="box-section">
          <div className="icon-arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              stroke=""
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path
                d="M 7 5.94963 C 7 5.02553 7 4.56348 7.1395 4.32617 C 7.2607 4.11978 7.4446 3.99972 7.639 4 C 7.8626 4.00033 8.12818 4.28897 8.6594 4.86625 L 12.3866 8.9166 C 12.7274 9.2869 12.8977 9.4721 12.9594 9.6958 C 13.0135 9.8919 13.0135 10.1081 12.9594 10.3042 C 12.8977 10.5279 12.7274 10.7131 12.3866 11.0834 L 8.6594 15.1337 C 8.12818 15.711 7.8626 15.9997 7.639 16 C 7.4446 16.0003 7.2607 15.8802 7.1395 15.6738 C 7 15.4365 7 14.9745 7 14.0504 L 7 5.94963 Z"
                fill="#181818"
              />
            </svg>
          </div>
          <div className="sub-section">
            <div className="list1">
              <div className="revision">Rev: 4</div>
              <div className="date">11/06/2025</div>
            </div>
            <div className="list2">
              <div className="code">Code:4</div>
              <div className="number">#21</div>
            </div>
            <div className="list3">
              <div className="received">Received on:</div>
              <div className="number2">IDOM-WTRAN-006707</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
